import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentContext = createContext(null);

const syncBusinessSchema = (s) => {
  try {
    const el = document.querySelector('script[type="application/ld+json"]');
    if (!el) return;
    const data = JSON.parse(el.textContent);
    if (data["@type"] !== "LocalBusiness") return;
    if (s.phone) data.telephone = s.phone;
    if (s.business_email) data.email = s.business_email;
    if (s.address) {
      const parts = s.address.split(",").map((p) => p.trim());
      data.address = {
        "@type": "PostalAddress",
        streetAddress: parts[0] || s.address,
        addressLocality: parts[1] || "George Town",
        addressRegion: parts[2] || "Grand Cayman",
        addressCountry: "KY",
      };
    }
    el.textContent = JSON.stringify(data);
  } catch (e) {
    console.error("schema sync failed", e);
  }
};

export const ContentProvider = ({ children }) => {
  const [packages, setPackages] = useState([]);
  const [addons, setAddons] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [galleryCategories, setGalleryCategories] = useState([]);
  const [experience, setExperience] = useState([]);
  const [heroStrips, setHeroStrips] = useState([]);
  const [brands, setBrands] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [services, setServices] = useState([]);
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const [p, a, g, gc, ex, hs, b, t, sv, st] = await Promise.all([
        axios.get(`${API}/content/packages`),
        axios.get(`${API}/content/addons`),
        axios.get(`${API}/content/gallery`),
        axios.get(`${API}/content/gallery-categories`),
        axios.get(`${API}/content/experience`),
        axios.get(`${API}/content/hero-strips`),
        axios.get(`${API}/content/brands`),
        axios.get(`${API}/content/testimonials`),
        axios.get(`${API}/content/services`),
        axios.get(`${API}/content/settings`),
      ]);
      setPackages(p.data);
      setAddons(a.data);
      setGallery(g.data);
      setGalleryCategories(gc.data);
      setExperience(ex.data);
      setHeroStrips(hs.data);
      setBrands(b.data);
      setTestimonials(t.data);
      setServices(sv.data);
      setSettings(st.data);
      syncBusinessSchema(st.data);
    } catch (e) {
      console.error("content load failed", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ packages, addons, gallery, galleryCategories, experience, heroStrips, brands, testimonials, services, settings, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
